module.exports = __webpack_public_path__ + "static/media/millimetre-design.34588a6d.png";